import React, { useEffect } from 'react';
import { Typography } from '@material-ui/core'

export const RouteSummaryBase = ({
  subscribeDepartureBookings, isFromUaRoute, routeId, unsubscribeDepartureBookings,
  routeBookingsSummary: {
    bookedHrn,
    ticketHrn,
    bookedZl,
    ticketZl,
    bookedCzk,
    ticketCzk,
    summary
  },
  date
}) => {
  useEffect(() => {
    if (!isFromUaRoute && routeId) {
      subscribeDepartureBookings(routeId)
    }

    return () => {
      unsubscribeDepartureBookings()
    }
  }, [routeId, date, isFromUaRoute, subscribeDepartureBookings, unsubscribeDepartureBookings])

  return (
    <section>
      <Typography variant='h5'>
        Підсумок:
      </Typography>

      {!!bookedZl && (
        <Typography variant='body1'>
          Заброньовані zl: <strong>{bookedZl}</strong> zl
        </Typography>
      )}

      {!!ticketZl && (
        <Typography variant='body1'>
          Квитки zl: <strong>{ticketZl}</strong> / <strong>{ticketZl * 0.75}</strong> zl
        </Typography>
      )}

      {!!bookedCzk && (
        <Typography variant='body1'>
          Заброньовані czk: <strong>{bookedCzk}</strong> czk
        </Typography>
      )}

      {!!ticketCzk && (
        <Typography variant='body1'>
          Квитки czk: <strong>{ticketCzk}</strong> / <strong>{ticketCzk * 0.75}</strong> czk
        </Typography>
      )}

      {!!bookedHrn && (
        <Typography variant='body1'>
          Заброньовані грн: <strong>{bookedHrn}</strong> грн
        </Typography>
      )}

      {!!ticketHrn && (
        <Typography variant='body1'>
          Квитки грн: <strong>{ticketHrn}</strong> / <strong>{ticketHrn * 0.75}</strong> грн
        </Typography>
      )}

      {!!summary && (
        <Typography variant='body1'>
          Сума: <strong>{summary}</strong> грн
        </Typography>
      )}
    </section>
  )
}


// WEBPACK FOOTER //
// ./src/components/RouteSummary/RouteSummary.js